import React from 'react';

export class DeprecationError extends Error {
  constructor(msg) {
    super(msg);
    this.name = 'DeprecationError';
  }
}

export class ExperimentalError extends Error {
  constructor(msg) {
    super(msg);
    this.name = 'ExperimentalError';
  }
}

const warningMap = new WeakMap();

export const deprecate = (
  obj,
  name = obj.name,
  additional = ' is a deprecated feature. Its usage is discouraged, and it may be removed in the near future.'
) => {
  const msg = `${name}${additional}`;
  console.warn(new DeprecationError(msg));
  warningMap.set(obj, msg);
  return obj;
};
export const experimental = (
  obj,
  name = obj.name,
  additional = ' is still an experimental feature, and it may change.'
) => {
  const msg = `${name}${additional}`;
  warningMap.set(obj, msg);
  return obj;
};

// TODO: use styled-jsx/design-tokens over inline styles
const warningStyles = {
  border: '1px solid #ddd',
  padding: '8px',
  borderRadius: '4px',
  marginTop: '8px',
  display: 'block',
  width: 'fit-content',
  background: 'mistyRose'
};

export const WarningBlock = ({ component }) =>
  warningMap.has(component) && (
    <em style={warningStyles}>
      <strong>Note: </strong>
      {warningMap.get(component)}
    </em>
  );
